import { Routes, Route, Navigate } from "react-router-dom";
import React from "react";

import RtlLayout from "layouts/rtl";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
const App = () => {
  // Initialize dark mode state
  const [darkmode, setDarkmode] = React.useState(false);

  React.useEffect(() => {
    // Initialize dark mode on app load
    const initializeDarkMode = () => {
      // Check localStorage for saved preference
      const savedDarkMode = localStorage.getItem("darkMode");

      if (savedDarkMode !== null) {
        // Use saved preference
        const isDark = savedDarkMode === "true";
        setDarkmode(isDark);
        if (isDark) {
          document.body.classList.add("dark");
        } else {
          document.body.classList.remove("dark");
        }
      } else {
        // Check system preference
        const prefersDark = window.matchMedia(
          "(prefers-color-scheme: dark)"
        ).matches;
        setDarkmode(prefersDark);
        if (prefersDark) {
          document.body.classList.add("dark");
        } else {
          document.body.classList.remove("dark");
        }
        // Save system preference to localStorage
        localStorage.setItem("darkMode", String(prefersDark));
      }
    };

    initializeDarkMode();
  }, []);
  return (
    <Routes>
      <Route path="auth/*" element={<AuthLayout />} />
      <Route path="admin/*" element={<AdminLayout />} />
      <Route path="rtl/*" element={<RtlLayout />} />
      <Route path="/" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
};

export default App;
